

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface TenantTaskParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}



export interface TenantTask {
    id?: string;
  tenantId: string;
  branchId: string;
  taskId: string;

  parameters?: TenantTaskParameter[];
  links?: any;
}



export abstract class TenantTaskData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<TenantTask[]>;
  abstract create(url: string,data: TenantTask[]): Observable<any>;
  abstract update(url: string,data: TenantTask): Observable<any>;
  abstract delete(url: string): Observable<any>;

}
